<template>
  <b-modal
    id="jdm-consent-modal"
    hide-footer
    :title="trans('consent')"
    ok-only
    :ok-title="trans('close')"
  >
    <div v-html="aboutHtml"></div>
    <b-form-group v-if="!!formUrl" :label="trans('form')">
      <b-input-group>
        <b-form-input v-model="formUrl" size="sm" readonly></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-primary" size="sm" v-clipboard:copy="formUrl" :title="trans('copy')" v-b-tooltip.hover class="px-2">
            <i class="fa fa-fw fa-copy"></i>
          </b-button>
          <a :href="formUrl" target="_forms" class="btn btn-outline-primary btn-sm px-2" :title="trans('visit')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-external-link-alt"></i>
          </a>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      consentForm: Object,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
      }
    },
    computed: {
      formUrl() {
        if (!this.consentForm) return null
        return this.consentForm.page_url
      },
      aboutHtml() {
        return window.lang == 'fr' ?
          '<p>Dans le cadre de cette édition 2025, le <strong>formulaire de consentement est obligatoire</strong> pour la participation de chaque enfant, complété par un parent ou un.e tuteur.trice.</p><p>Suite à une inscription, un courriel sera automatiquement envoyé au parent/tuteur.trice. Le courriel comporte un lien vers le formulaire.</p><p>Consultez la colonne <strong>Consentement</strong> dans le tableau des inscriptions pour faire le suivi. Une valeur vide indique que le formulaire n\' pas été rempli.</p><p>Le croisement entre une inscription et un consentement se fait avec l\'adresse courriel du parent/tuteur.trice et le nom et prénom de l\'enfant. Celles-ci doivent concorder.</p><p>Vous pouvez toujours envoyé un courriel vous-même. Voici l\'adresse URL du formulaire de consentement.</p>' :
          '<p>The <strong>Consent form</strong> is mandatory and must be filled by a parent or legal guardian.</p><p>After each registration, an email is automatically sent to the parent/guardian with a link to the consent form.</p><p>Track who hasn\'t filled the consent form via the <strong>Consent</strong> column in the registrations table. An empty value indicates we do not have the consent form for the participant.</p><p>We check consent by looking the email address of the parent/guardian and the first and last name of the participant. Those must match.</p><p>You can always email the parent/guardian yourself and provide the link to the consent form.</p>'
      }
    },
    mounted() {
      window.jdmConsentModal = this
    },
  }
</script>